module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CNCT ParaOverride-1",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Also by Joyce Carol Oates")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Barrens")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Beasts")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Rape: A Love Story")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Female of the Species: Tales of Mystery and Suspense")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Museum of Dr. Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A Fair Maiden")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Give Me Your Heart: Tales of Mystery and Suspense")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Corn Maiden and Other Nightmares")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Daddy Love")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Evil Eye: Four Novellas of Love Gone Wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("High Crime Area: Tales of Darkness and Dread")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e6ad19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook43521.vue
// module id = 66
// module chunks = 0